const Hero = () => {
  return (
    <div className="hero-home">
      <div className="hero-content md:px-28 px-10">
        {/* First Row */}
        <div className="">
          {/* Header */}
          <h1 className="uppercase text-pink-600 text-2xl font-medium">
            Your IT Growth Company
          </h1>
          <p className="text-3xl text-white font-light my-4 mb-36">
            We leverage technology to
            <br />
            simplify the way you work
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;
